import { HTMLProps } from 'react';

import {
  Backdrop,
  CircularProgress,
  Theme,
  alpha,
  makeStyles,
} from '@material-ui/core';

import classNames from 'classnames';

type LoadingOverlayMuiProps = HTMLProps<HTMLDivElement> & {
  loading?: boolean;
  height?: number;
  topOffset?: number;
};

type StyleProps = {
  topOffset: number;
};

const useStyles = makeStyles<Theme, StyleProps>(theme => ({
  backdropContainer: {
    position: 'absolute',
    top: ({ topOffset }) => topOffset,
    bottom: 0,
    left: 0,
    right: 0,
    pointerEvents: 'none',
    minHeight: 100,
  },
  backdrop: {
    position: 'sticky',
    height: 'min(100vh, 100%)',
    background: alpha(theme.palette.background.default, 0.7),
    zIndex: 0,
  },
  spinner: {
    position: 'sticky',
    transition: theme.transitions.create('bottom'),
  },
}));

export const LoadingOverlayMui = ({
  loading = false,
  height,
  topOffset = 0,
  className,
  ...props
}: LoadingOverlayMuiProps) => {
  const classes = useStyles({ topOffset });

  return (
    <div
      className={classNames(classes.backdropContainer, className)}
      {...props}
    >
      <Backdrop open={loading} className={classes.backdrop}>
        <CircularProgress
          className={classes.spinner}
          style={{
            bottom: height ? `${height / 2}px` : undefined,
          }}
        />
      </Backdrop>
    </div>
  );
};
